import TabelSftp from "./TabelSftp";

export default TabelSftp;